// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

// Vimeo custom controls + exit popup function

(function ($) {

  'use strict';

  // Vimeo embedded video exists
  if ($('iframe#iframeVimeo').length) {
    var iframe = $('iframe#iframeVimeo');
    var player = new Vimeo.Player(iframe);
    var videoProgressEditing = false;
    var videoDuration = 0;
    var videoDurationText = '00:00:00';
    var videoCurrentTime = new Date(null);
    var videoCurrentTimeText = '00:00:00';
    var controlBarTimer;
    var controlBarVisibilityTimer;
    var controlBarIsHidden = true;

    var isVideoAutoplay = false;

    var urlParams = new URLSearchParams(window.location.search);
    var urlDelayParam = urlParams.has('delay') ? urlParams.get('delay') : 0;

    if (urlDelayParam == 0)
    {
      enableHiddenContentReading(1000);
    }

    if ( isVideoAutoplay === true )
    {
      $('.embed-container').attr('data-video-is-playing', true);
      player.play();
    }

    else
    {
      $('.embed-container').attr('data-video-is-playing', false);
      player.pause();
    }

    player.on('playing', function(){
      refreshPlayingStatus(true);
    });

    player.on('bufferstart', function(){
      $('.video-player.js-video-player').addClass('buffering');
      $('.video-player.js-video-player.playing').removeClass('video-player-hide').addClass('video-player-show');
    });

    player.on('bufferend', function(){
      $('.video-player.js-video-player').removeClass('buffering');
      $('.video-player.js-video-player.playing').removeClass('video-player-show').addClass('video-player-hide');
    });

    player.on('pause', function(){
      refreshPlayingStatus(false);
    });

    player.on('ended', function(){
      updateVideoProgress(0);
      updateCurrentVideoTime(0);
      if ($('body.live').length) {
        $('.video-player.js-video-player').removeClass('video-player-show').addClass('video-player-hide');
      }
    });

    player.on('timeupdate', function(data){
      if (data.seconds > 10){
        $('.flag-started.action-flag > a').click();
      }
      if (data.percent > 0.98){
        $('.flag-completed.action-flag > a').click();
      }
      updateCurrentVideoTime(data.seconds);
      updateVideoProgress(data.seconds);
    });

    player.getDuration().then(function(duration) {
      videoDuration = duration;
      videoDurationText = new Date(videoDuration * 1000).toISOString().substr(11, 8);
      videoDurationText = formatDurationTimeText(videoDurationText);
      $('.control-bar.js-control-bar .progress-time .duration').text(videoDurationText);
      videoCurrentTimeText = formatCurrentTimeText(videoCurrentTimeText);
      $('.control-bar.js-control-bar .progress-time .current').text(videoCurrentTimeText);
    });

    player.getQualities().then(function(qualities) {
      var quality = qualities[1].id;
      if ($('body.live').length) {
        for (let i = 0; i < qualities.length; i++) {
          if (qualities[i].id ==='720p')
          {
            quality = '720p';
            break;
          }
        }
      }
      player.setQuality(quality);
    });

    $('.js-video-player').dblclick(function(){
      goFullScreen();
    });

    $('.js-video-player').click(function(){
      enableHiddenContentReading(urlDelayParam * 1000);
      playVideo();
    });

    $('.control-bar.js-control-bar .control-bar-play').click(function(){
      enableHiddenContentReading(urlDelayParam * 1000);
      playVideo();
    });

    $('.control-bar.js-control-bar .control-bar-fullscreen').click(function(){
      if (controlBarIsHidden) {
        $('.js-video-player').click();
      } else {
        goFullScreen();
      }
    });

    // Vimeo player progressbar
    $('.control-bar-container').click(function(e) {
      if (controlBarIsHidden) {
        $('.js-video-player').click();
      }
    });
    
    $('.control-bar.js-control-bar .control-bar-track').click(function(e) {
      if (controlBarIsHidden) {
        $('.js-video-player').click();
      } else {
        updateVideoProgressManually(e);
      }
    });

    $('.control-bar.js-control-bar .control-bar-track').mousedown(function(e) {
      if (!controlBarIsHidden) {
        videoProgressEditing = true;
        updateVideoProgressManually(e);
      }
    });

    $('.video-player.js-video-player').mouseup(function(e) {
      if (videoProgressEditing)
      {
        videoProgressEditing = false;
        updateVideoProgressManually(e);
      }
    });

    $('.control-bar-container').mouseup(function(e) {
      if (videoProgressEditing)
      {
        videoProgressEditing = false;
        updateVideoProgressManually(e);
      }
    });

    $('.video-player.js-video-player').mousemove(function(e) {
      if (!$('body.landing-page').length) {
        $('.video-player.js-video-player').removeClass('no-cursor');
        $('.control-bar-container').fadeIn(100);
        clearInterval(controlBarVisibilityTimer);
        controlBarVisibilityTimer = setTimeout(function () {
          controlBarIsHidden = false;
        }, 100);
        clearInterval(controlBarTimer);
        controlBarTimer = setTimeout(function () {
          $('.video-player.js-video-player').addClass('no-cursor');
          $('.control-bar-container').fadeOut(500);
          controlBarIsHidden = true;
        }, 3000);
      }

      if (videoProgressEditing)
      {
        updateVideoProgressManually(e);
      }
    });

    $('.control-bar-container').mousemove(function(e) {
      if (!$('body.landing-page').length) {
        $('.video-player.js-video-player').removeClass('no-cursor');
        $('.control-bar-container').fadeIn(100);
        clearInterval(controlBarVisibilityTimer);
        controlBarVisibilityTimer = setTimeout(function () {
          controlBarIsHidden = false;
        }, 100);
        clearInterval(controlBarTimer);
        controlBarTimer = setTimeout(function () {
          $('.video-player.js-video-player').addClass('no-cursor');
          $('.control-bar-container').fadeOut(500);
          controlBarIsHidden = true;
        }, 3000);
      }

      if (videoProgressEditing)
      {
        updateVideoProgressManually(e);
      }
    });

  }

  // Exit-popup exists
  if ($('.exit-popup-modal-close').length) {
    $('.exit-popup-modal-close').click(function(){
      enableHiddenContentReading();
    });
  }

  function playVideo() {
    var videoStatus = $('.embed-container').attr('data-video-is-playing');

    if (videoStatus == 'true')
    {
      // Pause the video
      player.pause();
    }
    else if (videoStatus == 'false')
    {
      // Play the video
      player.play();
    }
  }

  function updateVideoProgressManually(e) {
    // Get the current width of the slider
    //var rect = e.target.getBoundingClientRect();
    var rect = $('.control-bar.js-control-bar .control-bar-track').get(0).getBoundingClientRect();
    var fullWidth = $('.control-bar.js-control-bar .control-bar-track').width();
    var newWidth = e.clientX - rect.left;

    if (newWidth < 0)
    {
      newWidth = 0;
    }
    else if (newWidth > fullWidth)
    {
      newWidth = fullWidth;
    }

    // Update control-bar style
    $('.control-bar.js-control-bar .control-bar-track .processed').css('width',newWidth + 'px');

    // Update counter
    var seconds = (newWidth * videoDuration) / fullWidth;
    updateCurrentVideoTime(seconds);

    // Update player
    player.setCurrentTime(seconds);
  }

  function updateVideoProgress(seconds) {
    if (videoDuration > 0)
    {
      $('.control-bar.js-control-bar .control-bar-track .processed').css('width','0');
      var fullWidth = $('.control-bar.js-control-bar .control-bar-track').width();
      var newWidth = (fullWidth * seconds) / videoDuration;
      $('.control-bar.js-control-bar .control-bar-track .processed').css('width',newWidth + 'px');
    }
  }

  function updateCurrentVideoTime(seconds) {
    videoCurrentTime.setTime(seconds * 1000);
    videoCurrentTimeText = videoCurrentTime.toISOString().substr(11, 8);
    videoCurrentTimeText = formatCurrentTimeText(videoCurrentTimeText);
    $('.control-bar.js-control-bar .progress-time .current').text(videoCurrentTimeText);
  }

  function formatDurationTimeText(timeText) {
    var text = timeText;
    if (timeText.startsWith('00:'))
    {
      text = timeText.slice(3);
    }
    else if (timeText.startsWith('0'))
    {
      text = timeText.slice(1);
    }
    return text;
  }

  function formatCurrentTimeText(timeText) {
    var text = timeText;
    if (videoDurationText.length < 8)
    {
      text = timeText.slice(8-videoDurationText.length);
    }
    return text;
  }

  function refreshPlayingStatus(playing) {
    if (playing)
    {
      $('.video-player.js-video-player').removeClass('paused').addClass('playing');
      $('.control-bar.js-control-bar .control-bar-play').removeClass('paused').addClass('playing');
      $('.embed-container').attr('data-video-is-playing', true);
      $('.video-player.js-video-player.playing').removeClass('video-player-show').addClass('video-player-hide');
    }
    else
    {
      $('.video-player.js-video-player').removeClass('playing').addClass('paused');
      $('.control-bar.js-control-bar .control-bar-play').removeClass('playing').addClass('paused');
      $('.embed-container').attr('data-video-is-playing', false);
      $('.video-player.js-video-player.paused').removeClass('video-player-hide').addClass('video-player-show');
    }
  }

  function goFullScreen() {
    var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
    if(fullscreenElement){
      exitFullscreen();
      $('div.embed-container').removeClass('fullscreen');
    }else {
      launchIntoFullscreen(document.querySelector('div.embed-container'));
      $('div.embed-container').addClass('fullscreen');
    }
  }

  function launchIntoFullscreen(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  }

  function exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  }

  function showHiddenContent() {
    $('.js-hide').fadeIn(2000);
    $('.js-hide.btn').css('display','inline-block');
  }

  function disableExitPopup() {
    $(document.documentElement).off('mouseleave');
  }

  function enableHiddenContentReading(delay = 0) {
    setTimeout(showHiddenContent, delay);
    setTimeout(disableExitPopup, delay);
  }

  // Temporary Live page
  if ($('body.live .live-open').length) {
    $(window).on('load', function() {
       var currentDateTime = parseInt(Date.now(),10);
       var videoStartDateTime = parseInt($('.field-timer-jquery-countdown').attr('data-timestamp') + '000',10);

       if (currentDateTime < videoStartDateTime)
       {
         $('.live-open .live__field-help-text-video p.help-text-video').text('Az előadás még nem kezdődött el, várnod kell, míg a visszaszámláló a nullára ér. Ekkor magától megjelenik a videó, amit rákattintva tudsz elindítani. Ha esetleg nem jelenne meg automatikusan a videó, miután a számláló elérte a nullát, kérlek frissítsd az oldalt!');
         $('.live-open .live__field-start-datetime').show();
         setTimeout( function() { $('.live-open .live__field-help-text-video p.help-text-video').fadeOut(1000); },videoStartDateTime - currentDateTime);
         setTimeout( function() { $('.live-open .live__field-help-text-video p.help-text-video').text('A videót rákattintva tudod elindítani. Lehetőséged van teljes képernyős módban nézni a felvételt, és akár előre-vissza is tekerhetsz benne. Természetesen meg is állíthatod, majd újra elindíthatod, de vigyázz, mert ha lejár a videóra szánt idő, nem fogod tudni végignézni akkor sem, ha már elindítottad, és megállítottad! Azért nem kell megijedni, nem centiztük ki az időt, szóval nyugodtan kimehetsz a mosdóba közben, a lényeg, hogy az esetleges visszaéléseket megakadályoztuk.'); },videoStartDateTime - currentDateTime + 1000);
         setTimeout( function() { $('.live-open .live__field-help-text-video p.help-text-video').fadeIn(1000); },videoStartDateTime - currentDateTime + 1000);
         setTimeout( function() { $('.live-open .live__field-start-datetime').fadeOut(1000); },videoStartDateTime - currentDateTime);
         setTimeout( function() { $('.live-open .live__field-vimeo').fadeIn(1000); },videoStartDateTime - currentDateTime + 1000);
         setTimeout( function() { $('.live-open .live__field-help-text-video p.help-text-video').fadeOut(1000); },videoStartDateTime - currentDateTime + 7200000);
         setTimeout( function() { $('.live-open .live__field-help-text-video p.help-text-video').text('Ez az előadás sajnos már nem elérhető. Ha lemaradtál róla, vagy szívesen újranéznéd, az alábbi gombra kattintva lehetőséged van megvásárolni a konferencia teljes videóanyagát.'); },videoStartDateTime - currentDateTime + 7201000);
         setTimeout( function() { $('.live-open .live__field-help-text-video p.help-text-video').fadeIn(1000); },videoStartDateTime - currentDateTime + 7201000);
         setTimeout( function() { $('.live-open .live__field-vimeo').fadeOut(1000); },videoStartDateTime - currentDateTime + 7200000);
         setTimeout( function() { exitFullscreen(); player.destroy(); },videoStartDateTime - currentDateTime + 7201000);
         setTimeout( function() { $('.live-open .live__field-closing-cta-block').fadeIn(1000); },videoStartDateTime - currentDateTime + 7201000);
       }
       else if (currentDateTime < videoStartDateTime + 7200000)
       {
         $('.live-open .live__field-help-text-video p.help-text-video').text('A videót rákattintva tudod elindítani. Lehetőséged van teljes képernyős módban nézni a felvételt, és akár előre-vissza is tekerhetsz benne. Természetesen meg is állíthatod, majd újra elindíthatod, de vigyázz, mert ha lejár a videóra szánt idő, nem fogod tudni végignézni akkor sem, ha már elindítottad, és megállítottad! Azért nem kell megijedni, nem centiztük ki az időt, szóval nyugodtan kimehetsz a mosdóba közben, a lényeg, hogy az esetleges visszaéléseket megakadályoztuk.');
         $('.live-open .live__field-vimeo').show();
         setTimeout( function() { $('.live-open .live__field-help-text-video p.help-text-video').fadeOut(1000); },videoStartDateTime - currentDateTime + 7200000);
         setTimeout( function() { $('.live-open .live__field-help-text-video p.help-text-video').text('Ez az előadás sajnos már nem elérhető. Ha lemaradtál róla, vagy szívesen újranéznéd, az alábbi gombra kattintva lehetőséged van megvásárolni a konferencia teljes videóanyagát.'); },videoStartDateTime - currentDateTime + 7201000);
         setTimeout( function() { $('.live-open .live__field-help-text-video p.help-text-video').fadeIn(1000); },videoStartDateTime - currentDateTime + 7201000);
         setTimeout( function() { $('.live-open .live__field-vimeo').fadeOut(1000); },videoStartDateTime - currentDateTime + 7200000);
         setTimeout( function() { exitFullscreen(); player.destroy(); },videoStartDateTime - currentDateTime + 7201000);
         setTimeout( function() { $('.live-open .live__field-closing-cta-block').fadeIn(1000); },videoStartDateTime - currentDateTime + 7201000);
       }
       else
       {
         $('.live-open .live__field-help-text-video p.help-text-video').text('Ez az előadás sajnos már nem elérhető. Ha lemaradtál róla, vagy szívesen újranéznéd, az alábbi gombra kattintva lehetőséged van megvásárolni a konferencia teljes videóanyagát.');
         $('.live-open .live__field-closing-cta-block').show();
         player.destroy();
       }
    });
  }
  
  // Sales Multiple Offers
  if ($('body.landing-page .offers.pond-half').length && window.matchMedia('(min-width: 768px)').matches) {
    $(window).on('load', function() {
      let top1 = 0;
      let top2 = 0;
      let top3 = 0;
      let max = 0;

      // sales-title
      if ($('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-title').length) {
        top1 = $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-title').position().top;
        if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-title').length) {
          top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-title').position().top;
          if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').length) {
            top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').position().top;
            max = Math.max(top1, top2, top3);
            if (max > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-title').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-title').css('top', max - top1);
            }
            if (max > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-title').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-title').css('top', max - top2);
            }
            if (max > top3)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').css('top', max - top3);
            }
          }
          else
          {
            if (top2 > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-title').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-title').css('top', top2 - top1);
            }
            else if (top1 > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-title').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-title').css('top', top1 - top2);
            }
          }
        }
        else if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').length) {
          top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').position().top;
          if (top3 > top1)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-title').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-title').css('top', top3 - top1);
          }
          else if (top1 > top3)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').css('top', top1 - top3);
          }
        }
      }
      else if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-title').length
               && $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').length) {
        top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-title').position().top;
        top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').position().top;
        if (top3 > top2)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-title').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-title').css('top', top3 - top2);
        }
        else if (top2 > top3)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-title').css('top', top2 - top3);
        }
      }

      // sales-subtitle
      if ($('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-subtitle').length) {
        top1 = $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-subtitle').position().top;
        if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-subtitle').length) {
          top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-subtitle').position().top;
          if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').length) {
            top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').position().top;
            max = Math.max(top1, top2, top3);
            if (max > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-subtitle').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-subtitle').css('top', max - top1);
            }
            if (max > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-subtitle').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-subtitle').css('top', max - top2);
            }
            if (max > top3)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').css('top', max - top3);
            }
          }
          else
          {
            if (top2 > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-subtitle').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-subtitle').css('top', top2 - top1);
            }
            else if (top1 > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-subtitle').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-subtitle').css('top', top1 - top2);
            }
          }
        }
        else if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').length) {
          top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').position().top;
          if (top3 > top1)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-subtitle').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-subtitle').css('top', top3 - top1);
          }
          else if (top1 > top3)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').css('top', top1 - top3);
          }
        }
      }
      else if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-subtitle').length
               && $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').length) {
        top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-subtitle').position().top;
        top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').position().top;
        if (top3 > top2)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-subtitle').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-subtitle').css('top', top3 - top2);
        }
        else if (top2 > top3)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-subtitle').css('top', top2 - top3);
        }
      }

      // sales-text
      if ($('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-text').length) {
        top1 = $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-text').position().top;
        if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-text').length) {
          top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-text').position().top;
          if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').length) {
            top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').position().top;
            max = Math.max(top1, top2, top3);
            if (max > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-text').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-text').css('top', max - top1);
            }
            if (max > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-text').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-text').css('top', max - top2);
            }
            if (max > top3)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').css('top', max - top3);
            }
          }
          else
          {
            if (top2 > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-text').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-text').css('top', top2 - top1);
            }
            else if (top1 > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-text').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-text').css('top', top1 - top2);
            }
          }
        }
        else if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').length) {
          top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').position().top;
          if (top3 > top1)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-text').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-text').css('top', top3 - top1);
          }
          else if (top1 > top3)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').css('top', top1 - top3);
          }
        }
      }
      else if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-text').length
               && $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').length) {
        top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-text').position().top;
        top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').position().top;
        if (top3 > top2)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-text').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-text').css('top', top3 - top2);
        }
        else if (top2 > top3)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-text').css('top', top2 - top3);
        }
      }

      // sales-bonus
      if ($('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-bonus').length) {
        top1 = $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-bonus').position().top;
        if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-bonus').length) {
          top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-bonus').position().top;
          if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').length) {
            top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').position().top;
            max = Math.max(top1, top2, top3);
            if (max > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-bonus').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-bonus').css('top', max - top1);
            }
            if (max > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-bonus').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-bonus').css('top', max - top2);
            }
            if (max > top3)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').css('top', max - top3);
            }
          }
          else
          {
            if (top2 > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-bonus').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-bonus').css('top', top2 - top1);
            }
            else if (top1 > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-bonus').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-bonus').css('top', top1 - top2);
            }
          }
        }
        else if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').length) {
          top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').position().top;
          if (top3 > top1)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-bonus').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-bonus').css('top', top3 - top1);
          }
          else if (top1 > top3)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').css('top', top1 - top3);
          }
        }
      }
      else if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-bonus').length
               && $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').length) {
        top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-bonus').position().top;
        top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').position().top;
        if (top3 > top2)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-bonus').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-bonus').css('top', top3 - top2);
        }
        else if (top2 > top3)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-bonus').css('top', top2 - top3);
        }
      }

      // sales-full-price
      if ($('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-full-price').length) {
        top1 = $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-full-price').position().top;
        if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-full-price').length) {
          top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-full-price').position().top;
          if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').length) {
            top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').position().top;
            max = Math.max(top1, top2, top3);
            if (max > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-full-price').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-full-price').css('top', max - top1);
            }
            if (max > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-full-price').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-full-price').css('top', max - top2);
            }
            if (max > top3)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').css('top', max - top3);
            }
          }
          else
          {
            if (top2 > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-full-price').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-full-price').css('top', top2 - top1);
            }
            else if (top1 > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-full-price').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-full-price').css('top', top1 - top2);
            }
          }
        }
        else if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').length) {
          top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').position().top;
          if (top3 > top1)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-full-price').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-full-price').css('top', top3 - top1);
          }
          else if (top1 > top3)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').css('top', top1 - top3);
          }
        }
      }
      else if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-full-price').length
               && $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').length) {
        top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-full-price').position().top;
        top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').position().top;
        if (top3 > top2)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-full-price').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-full-price').css('top', top3 - top2);
        }
        else if (top2 > top3)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-full-price').css('top', top2 - top3);
        }
      }

      // sales-discount-price
      if ($('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-discount-price').length) {
        top1 = $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-discount-price').position().top;
        if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-discount-price').length) {
          top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-discount-price').position().top;
          if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').length) {
            top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').position().top;
            max = Math.max(top1, top2, top3);
            if (max > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-discount-price').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-discount-price').css('top', max - top1);
            }
            if (max > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-discount-price').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-discount-price').css('top', max - top2);
            }
            if (max > top3)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').css('top', max - top3);
            }
          }
          else
          {
            if (top2 > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-discount-price').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-discount-price').css('top', top2 - top1);
            }
            else if (top1 > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-discount-price').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-discount-price').css('top', top1 - top2);
            }
          }
        }
        else if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').length) {
          top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').position().top;
          if (top3 > top1)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-discount-price').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-discount-price').css('top', top3 - top1);
          }
          else if (top1 > top3)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').css('top', top1 - top3);
          }
        }
      }
      else if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-discount-price').length
               && $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').length) {
        top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-discount-price').position().top;
        top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').position().top;
        if (top3 > top2)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-discount-price').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-discount-price').css('top', top3 - top2);
        }
        else if (top2 > top3)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-discount-price').css('top', top2 - top3);
        }
      }

      // sales-cta-button
      if ($('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button').length) {
        top1 = $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button').position().top;
        if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button').length) {
          top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button').position().top;
          if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').length) {
            top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').position().top;
            max = Math.max(top1, top2, top3);
            if (max > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button').css('top', max - top1);
            }
            if (max > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button').css('top', max - top2);
            }
            if (max > top3)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').css('top', max - top3);
            }
          }
          else
          {
            if (top2 > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button').css('top', top2 - top1);
            }
            else if (top1 > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button').css('top', top1 - top2);
            }
          }
        }
        else if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').length) {
          top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').position().top;
          if (top3 > top1)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button').css('top', top3 - top1);
          }
          else if (top1 > top3)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').css('top', top1 - top3);
          }
        }
      }
      else if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button').length
               && $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').length) {
        top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button').position().top;
        top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').position().top;
        if (top3 > top2)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button').css('top', top3 - top2);
        }
        else if (top2 > top3)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button').css('top', top2 - top3);
        }
      }

      // sales-instalment
      if ($('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-instalment').length) {
        top1 = $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-instalment').position().top;
        if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-instalment').length) {
          top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-instalment').position().top;
          if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').length) {
            top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').position().top;
            max = Math.max(top1, top2, top3);
            if (max > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-instalment').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-instalment').css('top', max - top1);
            }
            if (max > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-instalment').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-instalment').css('top', max - top2);
            }
            if (max > top3)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').css('top', max - top3);
            }
          }
          else
          {
            if (top2 > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-instalment').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-instalment').css('top', top2 - top1);
            }
            else if (top1 > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-instalment').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-instalment').css('top', top1 - top2);
            }
          }
        }
        else if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').length) {
          top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').position().top;
          if (top3 > top1)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-instalment').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-instalment').css('top', top3 - top1);
          }
          else if (top1 > top3)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').css('top', top1 - top3);
          }
        }
      }
      else if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-instalment').length
               && $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').length) {
        top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-instalment').position().top;
        top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').position().top;
        if (top3 > top2)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-instalment').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-instalment').css('top', top3 - top2);
        }
        else if (top2 > top3)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-instalment').css('top', top2 - top3);
        }
      }

      // sales-cta-button-instalment
      if ($('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button-instalment').length) {
        top1 = $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button-instalment').position().top;
        if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button-instalment').length) {
          top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button-instalment').position().top;
          if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').length) {
            top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').position().top;
            max = Math.max(top1, top2, top3);
            if (max > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button-instalment').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button-instalment').css('top', max - top1);
            }
            if (max > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button-instalment').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button-instalment').css('top', max - top2);
            }
            if (max > top3)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').css('top', max - top3);
            }
          }
          else
          {
            if (top2 > top1)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button-instalment').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button-instalment').css('top', top2 - top1);
            }
            else if (top1 > top2)
            {
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button-instalment').css('position', 'relative');
              $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button-instalment').css('top', top1 - top2);
            }
          }
        }
        else if ($('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').length) {
          top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').position().top;
          if (top3 > top1)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button-instalment').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column1 .sales-cta-button-instalment').css('top', top3 - top1);
          }
          else if (top1 > top3)
          {
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').css('position', 'relative');
            $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').css('top', top1 - top3);
          }
        }
      }
      else if ($('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button-instalment').length
               && $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').length) {
        top2 = $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button-instalment').position().top;
        top3 = $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').position().top;
        if (top3 > top2)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button-instalment').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column2 .sales-cta-button-instalment').css('top', top3 - top2);
        }
        else if (top2 > top3)
        {
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').css('position', 'relative');
          $('body.landing-page .offers.pond-half .radix-layouts-column3 .sales-cta-button-instalment').css('top', top2 - top3);
        }
      }
    });
  }

}(jQuery));

